import { CommentGateway } from './comment-gateway.interface';

const baseUrl = 'gk/projects';
export class HttpCommentGateway implements CommentGateway {

  getCommentByProjectAndSlug(args: { projectId: string; slug: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/comments/${args.slug}`,
      method: 'GET',
    };
  }

  patchComment(args: { projectId: string; slug: string; data: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/comments/${args.slug}`,
      method: 'PATCH',
      data: args.data,
    };
  }
}
